import styled from "styled-components";

export const PaginationItem = styled.li`
  display: inline-block;
  list-style: none;
`;

PaginationItem.displayName = "PaginationItem";
